import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from '@stockcare-services/header-service/header.service';
import { Doctor } from '@stockcare-storage/doctor/doctor';
@Component({
  standalone: false,
  selector: 'app-doctor-card',
  templateUrl: './doctor-card.component.html',
  styleUrls: ['./doctor-card.component.scss']
})
export class DoctorCardComponent implements OnInit {
  @Input() doctor: Doctor;
  @Output() doctorSelected: EventEmitter<any> = new EventEmitter<any>();
  constructor(private router: Router, private headerService: HeaderService) {}

  ngOnInit() {}

  selectDoctor() {
    this.doctorSelected.next(this.doctor);
  }
}